module.exports = __webpack_public_path__ + "static/poster-4-869e2f4fd2e32aba2cd8d5a9a3d67c3b.jpg";